/* tslint:disable */

declare var Object: any;
export interface ERPinventoryAdjustmentValueInterface {
  "id"?: number;
}

export class ERPinventoryAdjustmentValue implements ERPinventoryAdjustmentValueInterface {
  "id": number;
  constructor(data?: ERPinventoryAdjustmentValueInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPinventoryAdjustmentValue`.
   */
  public static getModelName() {
    return "ERPinventoryAdjustmentValue";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPinventoryAdjustmentValue for dynamic purposes.
  **/
  public static factory(data: ERPinventoryAdjustmentValueInterface): ERPinventoryAdjustmentValue{
    return new ERPinventoryAdjustmentValue(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPinventoryAdjustmentValue',
      plural: 'ERPinventoryAdjustmentValues',
      path: 'ERPinventoryAdjustmentValues',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPinventoryAdjustmentValue.ts